import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSettingParams } from '../../../common/filterCompany/useSettingParams'
import { HandleDetail } from '../handleDetail'
import { HighlightInfo } from '../highlightInfo'
import { selectPeriod } from '../period/slice'
import { selectHighlight, selectLoading } from './store/slice'
import { getSummaryHighlight } from './store/thunk'

export const SummaryHighlight = () => {
  const dispatch = useDispatch()

  const settingParams = useSettingParams()
  const period = useSelector(selectPeriod)
  const highlight = useSelector(selectHighlight)
  const isLoading = useSelector(selectLoading())

  useEffect(() => {
    if (!settingParams) return
    dispatch(getSummaryHighlight({ ...settingParams, timeFrequency: period }))
  }, [settingParams, period])

  return (
    <>
      <HighlightInfo
        isLoading={isLoading}
        highlights={[
          {
            title: 'portfolio.common.TOTAL_COMPANIES',
            isI18n: true,
            detail: (
              <HandleDetail
                path="PortfolioInsights/Details"
                otherParams={{ param: { isHighlight: true } }}
              >
                {highlight.totalCompanies}
              </HandleDetail>
            ),
            isShowSeparator: true,
          },
          {
            title: 'portfolio.common.HIGHEST_CREDIT_RISK_COMPANIES',
            isI18n: true,
            detail: (
              <HandleDetail
                path="PortfolioInsights/HighestScoreDetails"
                otherParams={{
                  timeFrequency: period,
                  type: 'HighestCreditRisk',
                  modelId: 3,
                }}
              >
                {highlight.highestCreditRiskCompanies}
              </HandleDetail>
            ),
            isShowSeparator: false,
          },
          {
            title: 'portfolio.common.NEW_HIGHEST_CREDIT_RISK_COMPANIES',
            isI18n: true,
            detail: (
              <HandleDetail
                path="PortfolioInsights/HighestScoreDetails"
                otherParams={{
                  timeFrequency: period,
                  type: 'NewHighestCreditRisk',
                  modelId: 3,
                }}
              >
                {highlight.newHighestCreditRiskCompanies}
              </HandleDetail>
            ),
            isShowSeparator: true,
          },
          {
            title: 'portfolio.common.HIGHEST_GROWTH_POTENTIAL_COMPANIES',
            isI18n: true,
            detail: (
              <HandleDetail
                path="PortfolioInsights/HighestScoreDetails"
                otherParams={{
                  timeFrequency: period,
                  type: 'HighestGrowthPotential',
                  modelId: 2,
                }}
              >
                {highlight.highestGrowthPotentialCompanies}
              </HandleDetail>
            ),
            isShowSeparator: false,
          },
          {
            title: 'portfolio.common.NEW_HIGHEST_GROWTH_POTENTIAL_COMPANIES',
            isI18n: true,
            detail: (
              <HandleDetail
                path="PortfolioInsights/HighestScoreDetails"
                otherParams={{
                  timeFrequency: period,
                  type: 'NewHighestGrowthPotential',
                  modelId: 2,
                }}
              >
                {highlight.newHighestGrowthPotentialCompanies}
              </HandleDetail>
            ),
            isShowSeparator: false,
          },
        ]}
      />
    </>
  )
}
